export default __webpack_public_path__ + "0f1ac1bdbbfbc3e596c2d928ab065175.png";